import { createApiClient, createLocalStorageTokenStorage } from '@lex/api-client';

export const tokenStorage = createLocalStorageTokenStorage('lex_auth');

export const apiClient = createApiClient({
  baseUrl: import.meta.env.VITE_API_URL ?? '',
  storage: tokenStorage,
  onUnauthorized: () => {
    tokenStorage.clear();
    if (window.location.pathname !== '/login') {
      window.location.assign('/login?expired=1');
    }
  },
});
